import Cookie from "js-cookie";
import UrlParams from "../tools/UrlParams";
import storage from "../helpers/LocalStorageWrapper";
import OauthKit from "./OauthKit";
import GTM from "../api/GTM";
import gapi_config from "../api/grpc/config";
import env from "../tools/Environment";
class AuthService {
  constructor() {
    this.store = null;
    this.user = null;
    this.user_email = null;
    this._js_api = null;
    this.mail_domains = ["bk.ru", "mail.ru", "mail.ua", "corp.mail.ru", "list.ru", "inbox.ru"];
    /**
     *
     * @type {BaseApi|null} project Api
     */
    this.api = null;
    this.setUserCookie();
  }

  getJsApi() {
    if (this._js_api) {
      return this._js_api;
    }
    this._js_api = new OauthKit(this.store, this.config);
    return this._js_api;
  }

  /**
   *
   * @param {AuthServiceConfig} config service config
   */
  setConfig(config) {
    this.config = config;
    this.store = this.config.getConfig().store;
    this.api = this.config.getConfig().api;
    this.afterConfigSetInit();
  }

  getConfig() {
    return this.config.getConfig();
  }

  afterConfigSetInit() {
    if (this.config.getConfig().referral && this.config.getConfig().referral.enabled) {
      this.checkReferralParam();
    }
  }

  checkReferralParam() {
    const ref_param = UrlParams.get(this.config.getConfig().referral.url_param);
    if (ref_param) {
      Cookie.set(this.config.getConfig().referral.cookie_param, ref_param, { expires: 1 });
    }
  }

  showSignup() {
    GTM.sendEvent("ch.registration.init");
    this.getJsApi().showSignup();
  }

  showSignin() {
    this.getJsApi().showLogin();
  }

  showProjectReg() {
    GTM.sendEvent("ch.registration.project", this.getUserData());
    return this.getJsApi().showProjectRegister();
  }

  showVkAuth() {
    this.getJsApi().showVkSignin();
  }

  showOkAuth() {
    this.getJsApi().showOkAuth();
  }

  showMailRuAuth() {
    this.getJsApi().showMailRuSignin();
  }

  showMyGamesAuth() {
    this.getJsApi().showMyGamesSignin();
  }

  showMyGamesLogin() {
    this.getJsApi().showMyGamesSignin();
  }

  showSteamSignin() {
    this.getJsApi().showSteamSignin();
  }

  showEgSignin() {
    this.getJsApi().showEgSignin();
  }

  showPsSignin() {
    this.getJsApi().showPsSignin();
  }

  showXboxSignin() {
    this.getJsApi().showXboxSignin();
  }
  showFbSignin() {
    this.getJsApi().showFbSignin();
  }
  showGoogleSignin() {
    this.getJsApi().showGoogleSignin();
  }
  showTwitchSignin() {
    this.getJsApi().showTwitchSignin();
  }
  showTwitterSignin() {
    this.getJsApi().showTwitterSignin();
  }

  /**
   *
   * @param {object|null} user api user response
   */
  setUser(user) {
    if (user) {
      this.user = user;
      this.prepareUser();
    }
  }
  logVisit() {
    const params = {
      type: this.user ? "user" : "guest",
    };
    const user_data = this.getUserData();
    if (user_data.userID) {
      params.userID = user_data.userID;
    }
    GTM.sendEvent("ch.visit.v2", params);
  }

  /**
   * Setup some counters/metrics cookie from current url search params
   */
  setUserCookie() {
    /**
     *
     * key - url get param, value - cookie name; you can add new url:cookie pairs
     */
    const cookie_to_set = {
      _1ld: "_1ld",
    };
    for (let url_param in cookie_to_set) {
      if (cookie_to_set.hasOwnProperty(url_param)) {
        let value = UrlParams.get(url_param);
        if (value) {
          Cookie.set(cookie_to_set[url_param], value, { expires: 1 });
        }
      }
    }
  }

  /**
   *
   * @return {object|null} prepared user
   */
  getUser() {
    return this.user;
  }

  prepareUser() {
    this.user.display_name = this.getUserDisplayName();
    this.user.newbie = this._isNewUser();
    if (window.eventBroker) {
      window.eventBroker.triggerEventQueue("after_auth");
    }
    if (this.user.newbie) {
      GTM.sendEvent("ch.registration.finish", this.getUserData());
      if (window.eventBroker) {
        window.eventBroker.triggerEventQueue("after_reg");
      }
    }
    //support onelink "u" user param, see views/partials/1link_script.blade.php
    storage.setItem(this.config.getConfig().user.profile_storage_key, this.user.id);

    // set X-ProfileId header with current user id
    this.api.setProfileIdHeader(this.user.id);
    // set X-ProfileId header with current user id
    gapi_config.setProfileIdHeader(this.user.id);
  }

  /**
   * New (newbie) user it's user who registered in project just now;
   * We processed newbie status only once
   * @return {boolean}
   * @private
   */
  _isNewUser() {
    if (!this.user || this._isUserAlreadyProcessed(this.user.id)) {
      return false;
    }
    if (this._isNewUserRu() || this._isNewUserMycom()) {
      this._markUserAsProcessed(this.user.id);
      return true;
    }
    return false;
  }

  //ru detect new registered user, user was registered by api call
  _isNewUserRu() {
    if (storage.getItem(this.config.getConfig().user.new_user_storage_key)) {
      storage.removeItem(this.config.getConfig().user.new_user_storage_key);
      return true;
    }
  }

  //mycom detect new registered user
  _isNewUserMycom() {
    const AFTER_REGISTER_TIME = 1000 * 60 * 60 * 24; //24 hours
    const register_date = new Date(this.user.registered_at);
    const diff = Math.abs(new Date() - register_date);
    return diff < AFTER_REGISTER_TIME;
  }

  _markUserAsProcessed(user_id) {
    if (!user_id) {
      return console.error("Invalid user id");
    }
    let processed_user_ids = storage.getItem(
      this.config.getConfig().user.new_user_already_processed_storage_key
    );
    if (!processed_user_ids) {
      processed_user_ids = [];
    }
    if (processed_user_ids.indexOf(user_id) === -1) {
      processed_user_ids.push(user_id);
      storage.setItem(
        this.config.getConfig().user.new_user_already_processed_storage_key,
        processed_user_ids
      );
    }
  }

  _isUserAlreadyProcessed(user_id) {
    let processed_user_ids = storage.getItem(
      this.config.getConfig().user.new_user_already_processed_storage_key
    );
    if (!processed_user_ids) {
      return false;
    }
    //support old version, convert string/number to array and update storage data
    if (typeof processed_user_ids !== "object") {
      processed_user_ids = [parseInt(processed_user_ids, 10)];
      storage.setItem(
        this.config.getConfig().user.new_user_already_processed_storage_key,
        processed_user_ids
      );
    }
    if (Array.isArray(processed_user_ids)) {
      return processed_user_ids.indexOf(user_id) > -1;
    } else {
      console.error("Unsupported data format in localStorage, panic mode!");
    }
  }

  userRegister(gc_redirect = false, subscription = 0, reload = true) {
    if (!this.api) {
      throw new Error("we need API!");
    }
    const method_name = env.isVkPlay() || env.isMailru() ? "userRegisterV2" : "userRegister";

    return this.api.userService[method_name](subscription, 1)
      .run()
      .then(response => {
        if (!response.data.error) {
          storage.setItem(this.config.getConfig().user.new_user_storage_key, "1");
          if (subscription) {
            return this.userRegisterOauthSubscribe();
          } else {
            return this.prepareUserRegisterResponse();
          }
        } else {
          return this.prepareUserRegisterResponse(false, response.data.error);
        }
      })
      .then(result => {
        if (result.status) {
          return this.finishReg(gc_redirect, reload);
        } else {
          console.error("PANIC MODE! REG FAILED");
          return result;
        }
      });
  }

  userRegisterOauthSubscribe() {
    const login = this.getUserEmail();
    if (!this.isSocialLogin(login)) {
      return this.api.mailerService
        .sendCheckMail(login)
        .run()
        .then(response => {
          if (response.data.result && response.data.result.status === "ok") {
            GTM.sendEvent("ch.mailer.subscribed", this.getUserData());
          }
          return this.prepareUserRegisterResponse();
        });
    } else {
      return this.prepareUserRegisterResponse();
    }
  }

  finishReg(gc_redirect = false, reload = true) {
    if (gc_redirect) {
      window.open(gc_redirect);
    } else if (reload) {
      location.reload();
    }
    return true;
  }

  /**
   * It uses to return the exact error back to a component, which called userRegister method.
   * @param {boolean} status
   * @param {object} extra_info it uses to provide some additional information, for example it can be error object
   * @return {object}
   */
  prepareUserRegisterResponse(status = true, extra_info = {}) {
    if (status) {
      return {
        status,
      };
    } else {
      return {
        status,
        error: extra_info,
      };
    }
  }

  isSocialLogin(login) {
    let origin = this.getLoginOrigin(login);
    return !!(origin && origin.indexOf(".") < 0);
  }

  isMailLogin(login) {
    return this.mail_domains.indexOf(this.getLoginOrigin(login)) > -1;
  }

  getUserDisplayName() {
    const user = this.user;
    if (!user) {
      console.error("no user!");
      return "";
    }
    //okay, it's custom nickname
    if (user.nickname && user.nickname.substr(0, 2) !== "u_") {
      return user.nickname;
    }
    //social name;
    if (user.full_name) {
      return user.full_name;
    }
    if (user.login) {
      return user.login;
    }
    return user.nickname;
  }

  getLoginOrigin(login) {
    const domain = login.split("@")[1];
    return domain ? domain.toLowerCase() : false;
  }
  isSteamUser(login) {
    return login.slice(-6) === "@steam";
  }
  getUserPlatform(login) {
    return login.split("@")[1];
  }

  logout() {
    return this.api.request({ method: "post", url: "/gw/oauth/sezam/logout" }).then(() => {
      location.reload();
    });
  }

  /**
   * There are 4 different ways to download a game.
   * 1) download game by a direct link - it's  a deprecated way and might be deleted in the future;
   * Instead, You may use the third way, or you can consider using openDownloadLink method;
   * 2) download steam client (only for steam users) - you must declare separated_steam_downloading param in your AuthServiceConfig
   * and steam_download_url in your GEMS config
   * 3) download game by a direct link, which is provided by AuthServiceConfig.
   * It's a replacement for the first deprecated way. Now it's using only for WW3 project.
   * You must declare separated_gc_downloading param in your AuthServiceConfig
   * and gc_download_url in your GEMS config.
   * 4) Platform gc download method - the main default way of downloading game client.
   * It uses when other three methods undeclared or unavailable.
   * @param game_link
   */
  downloadGameCenter(game_link = "") {
    if (game_link) {
      this.openDownloadLink(game_link);
    } else {
      //no direct download links for user's platfolm
      if (!this.checkAndDownloadDirectLink()) {
        //no special gc downloading
        if (!this.checkAndDownloadSeparatedGc()) {
          // default platform gc downloading
          this.getJsApi().detectAndDownload();
        }
      }
    }
    GTM.sendEvent("ch.click.download", this.getUserData());
  }

  /**
   * Special client download for steam users.
   * Returns true if it's a steam user and separated_steam_downloading param in config is enabled for the current project,
   * otherwise returns false.
   * @return {boolean}
   */
  checkAndDownloadDirectLink() {
    // If there is no direct_download_urls or user, then return with false
    if (!window.__GEMS.direct_download_urls || !this.user) {
      return false;
    }

    const { direct_download_urls } = window.__GEMS;
    const user_platform = this.getUserPlatform(this.user.login);

    // If there is no direct link for current platform, then return with false
    if (!direct_download_urls[user_platform]) {
      return false;
    }
    const config = this.config.getConfig();
    if (config.gc && config.gc.same_tab_downloading) {
      window.location.href = direct_download_urls[user_platform];
      return true;
    } else {
      // In positive cases we open window with necessary link
      window.open(direct_download_urls[user_platform], "_blank");
      return true;
    }
  }
  /**
   * Special client download for separated gc client (WW3 project, for example).
   * Returns true if separated_gc_downloading param in config is enabled for the current project,
   * otherwise returns false.
   * @return {boolean}
   */
  checkAndDownloadSeparatedGc() {
    const config = this.config.getConfig();
    //special gc download by direct link
    if (config.gc && config.gc.separated_gc_downloading) {
      if (window.__GEMS && window.__GEMS.gc_download_url) {
        this.openDownloadLink(window.__GEMS.gc_download_url);
      } else {
        console.error("You must declare 'gc_download_url' in your GEMS config");
      }
      return true;
    }
    return false;
  }
  openDownloadLink(download_link) {
    const link = document.createElement("a");
    link.href = download_link;
    link.setAttribute("download", ""); //or any other extension
    document.body.appendChild(link);
    link.click();
  }

  getUserData(user) {
    return { userID: user ? user.id : this.user ? this.user.id : null };
  }

  setUserEmail(email) {
    this.user_email = email;
  }

  getUserEmail() {
    return this.user ? this.user.login : this.user_email;
  }

  getMailSubscribeWhitelist() {
    return this.mail_domains;
  }
}

const service = new AuthService();
export default service;
